// import { SPORTS } from '../constant/sports'

export const sportTrials = [
    // {
    //     name: SPORTS.SOCCER,
    //     trialTime: 180000, // 3 minutes
    // },
    // {
    //     name: SPORTS.NFL,
    //     trialTime: 180000, // 3 minutes
    // },
    // {
    //     name: SPORTS.NCAAF,
    //     trialTime: 180000, // 3 minutes
    // },
    // {
    //     name: SPORTS.NBA,
    //     trialTime: 180000, // 3 minutes
    // },
    // {
    //     name: SPORTS.NHL,
    //     trialTime: 180000, // 3 minutes
    // },
    // {
    //     name: SPORTS.NCAAB,
    //     trialTime: 180000, // 3 minutes
    // },
]

export const defaultTrialTime = 60000 // 1 minute (default time for sports not explicitly listed)
